import {InputSProps} from "@FRAMEWORK/ui/types/d";
import React, {forwardRef} from "react";
import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/common/input_spr.png";

interface Component extends InputSProps {
	id?: string;
	value?: string;
	checked: boolean;
	bg?: string;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Wrapper = styled.span`
	display: inline-block;
	position: relative;
	width: 24px;
	height: 24px;
	flex-shrink: 0;
`;

const HiddenInput = styled.input`
	position: absolute;
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	opacity: 0;
	cursor: pointer;
	z-index: 1;
	&:disabled {
		cursor: initial;
	}
`;

const Visual = styled.span<{checked?: boolean; disabled?: boolean}>`
	display: block;
	width: 24px;
	height: 24px;
	background-image: url(${SpriteImage});
	background-repeat: no-repeat;
	background-size: 200px 200px;
	background-position: ${({checked, disabled}) => {
		if (disabled) return "-24px -24px";
		if (checked) return "0 -24px";
		return "0 0";
	}};
	pointer-events: none;
`;

const CheckboxN = forwardRef<HTMLInputElement, Component>(({id, checked, disabled, ...props}: Component, ref) => (
	<Wrapper>
		<HiddenInput type="checkbox" id={id} checked={checked} disabled={disabled} {...props} ref={ref} />
		<Visual checked={checked} disabled={disabled} />
	</Wrapper>
));

export default CheckboxN;
